import React from 'react';

import ListItemText from '../ListItemText';
import ListItemTextWithLink from '../ListItemTextWithLink';
import ListItemSubtitleText from '../ListItemSubtitleText';
import { ListSubItemTextProps } from '../ListSubItemText';

import styles from './index.module.scss';

export enum TextType {
  TEXT = 'text',
  TEXT_WITH_LINK = 'textWithLink'
}

export interface ListItem {
  type: TextType;
  text: string;
  link?: string;
  linkText?: string;
  subItems?: ListSubItemTextProps[];
}

export interface ListGroupProps {
  groupTitle?: string;
  items: ListItem[];
  icon: JSX.Element;
}

const ListGroup: React.FC<ListGroupProps> = ({ groupTitle, items, icon }) => {
  return (
    <div className={styles.listGroup}>
      {groupTitle && (
        <ListItemSubtitleText
          classsName={styles.groupTitle}
          text={groupTitle}
       />
      )}
      <div className={styles.list}>
        {items.map((item, index) => {
          if (item.type === TextType.TEXT_WITH_LINK) {
            return (
              <ListItemTextWithLink
                key={item.text + index}
                text={item.text}
                icon={icon}
                link={item.link || ''}
                linkText={item.linkText || ''}
                subItems={item.subItems}
             />
            );
          }

          return (
            <ListItemText
              key={item.text + index}
              text={item.text}
              icon={icon}
              subItems={item.subItems}
           />
          );
        })}
      </div>
    </div>
  );
};

export default ListGroup;
